import { Dispatcher } from 'flux';
import _ from 'lodash';

import { toJS } from '../helpers/Immutable';

export default new Dispatcher();

export function logActionHandler (payload) {
    /* eslint-disable no-console */
    if (!payload.actionType) {
        console.warn('Invalid action type dispatched');
    } else {
        if (console.groupCollapsed) {
            console.groupCollapsed(`%c Dispatched: ${payload.actionType}`, 'color: #bada55');
            console.log('Original: ', payload);
            const readablePayload = _.reduce(payload, (acc, value, key) => {
                acc[key] = toJS(value);
                return acc;
            }, {});
            console.log('Readable: ', readablePayload);
            console.trace();
            console.groupEnd();
        }
    }
    /* eslint-enable no-console */
}
